import React from 'react';
import RosterApp from './pages/RosterApp';
export { default as SummaryPage } from './pages/SummaryPage';
export { default as TeamSquadPage } from './pages/TeamSquadPage';
export { default as PlayersPage } from './pages/PlayersPage';

const RosterAppEntry: React.FC = () => {
  return <RosterApp />;
};

export default RosterAppEntry;

